import { render, staticRenderFns } from "./pages10.vue?vue&type=template&id=49c99606&scoped=true&"
import script from "./pages10.vue?vue&type=script&lang=js&"
export * from "./pages10.vue?vue&type=script&lang=js&"
import style0 from "./pages10.vue?vue&type=style&index=0&id=49c99606&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c99606",
  null
  
)

export default component.exports